import { FILE_SHARE_MODE_NONE } from "core/consts";
import { Filev2, RadioOption } from "core/types";

export function getFormInputValue({
  share_mode,
  shared_with,
}: {
  share_mode?: Filev2["share_mode"];
  shared_with: Filev2["shared_with"];
}) {
  let initiallySelectedCareproviders: RadioOption[] = [];

  if (shared_with) {
    if (shared_with.selected_careproviders) {
      initiallySelectedCareproviders =
        shared_with.selected_careproviders.reduce<RadioOption[]>(
          (acc, { careprovider }) => {
            if (careprovider?.id && careprovider.name) {
              return [
                ...acc,
                {
                  id: careprovider.id,
                  label: careprovider.name,
                  value: careprovider.id,
                },
              ];
            }
            return acc;
          },
          [],
        );
    }
  }

  return {
    selected_receivers: initiallySelectedCareproviders,
    share_mode: share_mode ?? FILE_SHARE_MODE_NONE,
  };
}
